var _g, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopProductsTableIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 579,
    height: 338,
    viewBox: "0 0 579 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tjyctglqma)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9.673,
    width: 549.406,
    height: 308.977,
    rx: 19.13,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.587,
    y: 13.26,
    width: 542.232,
    height: 301.804,
    rx: 15.543,
    stroke: "#fff",
    strokeWidth: 7.174
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.572,
    y: 38.496,
    width: 450.632,
    height: 251.333,
    rx: 9.565,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#8CA1FF",
    d: "M81.365 131.107H486.41v20.59H81.365zM81.365 168.991H486.41v20.59H81.365zM81.365 206.877H486.41v20.59H81.365zM81.365 244.762H486.41v20.59H81.365z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M81.365 84.986H486.41v25.531H81.365z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93.722,
    y: 94.869,
    width: 54.921,
    height: 3.294,
    rx: 1.647,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 209.057,
    y: 94.869,
    width: 36.385,
    height: 3.294,
    rx: 1.647,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93.722,
    y: 139.343,
    width: 36.385,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 220.042,
    y: 139.343,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 276.337,
    y: 139.343,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 332.632,
    y: 139.343,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 388.925,
    y: 139.343,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 445.22,
    y: 139.343,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 93.722,
    y: 177.228,
    width: 36.385,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 220.042,
    y: 177.228,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 276.337,
    y: 177.228,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 332.632,
    y: 177.228,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 388.925,
    y: 177.228,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 445.22,
    y: 177.228,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 93.722,
    y: 215.113,
    width: 36.385,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 220.042,
    y: 215.113,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 276.337,
    y: 215.113,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 332.632,
    y: 215.113,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 388.925,
    y: 215.113,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 445.22,
    y: 215.113,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 93.722,
    y: 252.998,
    width: 36.385,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 220.042,
    y: 252.998,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 276.337,
    y: 252.998,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 332.632,
    y: 252.998,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 388.925,
    y: 252.998,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 445.22,
    y: 252.998,
    width: 14.417,
    height: 3.294,
    rx: 1.647,
    fill: "#909090"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 265.351,
    y: 94.869,
    width: 36.385,
    height: 3.294,
    rx: 1.647,
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 321.647,
    y: 94.869,
    width: 36.385,
    height: 3.294,
    rx: 1.647,
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 377.94,
    y: 94.869,
    width: 36.385,
    height: 3.294,
    rx: 1.647,
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 434.236,
    y: 94.869,
    width: 36.385,
    height: 3.294,
    rx: 1.647,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 258.638,
    y: 76.445,
    width: 50.499,
    height: 195.391,
    rx: 4.783,
    fill: "#63F5D9",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.534 70.576V60.4h-3.717v-1.54h9.056v1.54h-3.716v10.177h-1.623zm8.794-8.336c.781 0 1.49.19 2.126.57a3.963 3.963 0 0 1 1.523 1.54c.38.647.57 1.367.57 2.159a4.16 4.16 0 0 1-.57 2.142 4.117 4.117 0 0 1-1.523 1.54 4.165 4.165 0 0 1-2.126.553 4.257 4.257 0 0 1-2.142-.553 4.246 4.246 0 0 1-1.54-1.54 4.257 4.257 0 0 1-.553-2.142c0-.793.184-1.512.552-2.16a4.12 4.12 0 0 1 1.524-1.54 4.19 4.19 0 0 1 2.16-.569zm-2.745 4.269c0 .513.123.982.368 1.406a2.724 2.724 0 0 0 2.377 1.356c.491 0 .949-.123 1.373-.368a2.75 2.75 0 0 0 1.004-.988c.246-.424.368-.893.368-1.406 0-.513-.122-.982-.368-1.406a2.675 2.675 0 0 0-1.004-1.021 2.693 2.693 0 0 0-1.373-.369c-.502 0-.965.123-1.39.369a2.714 2.714 0 0 0-.987 1.02 2.755 2.755 0 0 0-.368 1.407zm13.007-2.796c-.748 0-1.378.23-1.891.687-.514.457-.81 1.049-.888 1.774v.636c.078.725.374 1.317.888 1.775.513.457 1.143.686 1.891.686.513 0 .982-.123 1.406-.368a2.752 2.752 0 0 0 1.373-2.41 2.752 2.752 0 0 0-1.373-2.411 2.756 2.756 0 0 0-1.406-.369zm-4.335-1.305h1.556v1.64a3.281 3.281 0 0 1 1.239-1.339c.536-.312 1.155-.469 1.858-.469.725 0 1.389.19 1.992.57.614.379 1.094.898 1.44 1.556.357.647.535 1.356.535 2.126 0 .77-.178 1.484-.535 2.143a3.984 3.984 0 0 1-1.44 1.54c-.603.38-1.267.569-1.992.569-.703 0-1.322-.156-1.858-.469a3.28 3.28 0 0 1-1.239-1.339v4.603h-1.556V62.408zm18.808 1.891c.558 0 1.027-.19 1.407-.569.39-.38.585-.842.585-1.39 0-.546-.195-1.004-.585-1.372-.38-.38-.849-.569-1.407-.569h-2.879v3.9h2.879zm-4.502-5.44h4.502c.681 0 1.295.15 1.842.452.547.301.976.72 1.289 1.255.312.525.468 1.116.468 1.775 0 .658-.156 1.255-.468 1.79a3.483 3.483 0 0 1-1.289 1.256 3.754 3.754 0 0 1-1.842.452h-2.879v4.737h-1.623V58.86zm9.592 3.549h1.557v1.188c.246-.424.558-.753.938-.987.39-.235.825-.352 1.305-.352.268 0 .519.034.753.1v1.423a2.52 2.52 0 0 0-.803-.133c-.625 0-1.149.217-1.574.652-.412.424-.619.982-.619 1.674v4.603h-1.557v-8.168zm9.178-.168c.781 0 1.49.19 2.126.57a3.962 3.962 0 0 1 1.523 1.54c.38.647.569 1.367.569 2.159 0 .781-.189 1.495-.569 2.142a4.116 4.116 0 0 1-1.523 1.54 4.166 4.166 0 0 1-2.126.553 4.254 4.254 0 0 1-2.142-.553 4.236 4.236 0 0 1-1.54-1.54 4.25 4.25 0 0 1-.553-2.142c0-.793.184-1.512.553-2.16a4.116 4.116 0 0 1 1.523-1.54 4.19 4.19 0 0 1 2.159-.569zm-2.745 4.269c0 .513.123.982.368 1.406a2.723 2.723 0 0 0 2.377 1.356c.491 0 .949-.123 1.373-.368a2.746 2.746 0 0 0 1.004-.988 2.75 2.75 0 0 0 .368-1.406 2.75 2.75 0 0 0-.368-1.406 2.671 2.671 0 0 0-1.004-1.021 2.695 2.695 0 0 0-1.373-.369c-.502 0-.965.123-1.389.369a2.718 2.718 0 0 0-.988 1.02 2.76 2.76 0 0 0-.368 1.407zm12.326 2.762c.747 0 1.378-.229 1.891-.686.513-.458.809-1.05.887-1.775v-.636c-.078-.725-.374-1.317-.887-1.774-.513-.458-1.144-.687-1.891-.687a2.76 2.76 0 0 0-1.407.369c-.424.245-.758.58-1.004 1.004a2.76 2.76 0 0 0-.368 1.406c0 .513.123.982.368 1.406.246.424.58.759 1.004 1.005a2.76 2.76 0 0 0 1.407.368zm-4.286-2.779c0-.77.173-1.479.519-2.126a4.12 4.12 0 0 1 1.44-1.556 3.747 3.747 0 0 1 2.008-.57c.704 0 1.317.157 1.842.47.535.312.954.758 1.255 1.338V58.86h1.557v11.717h-1.557v-1.64a3.238 3.238 0 0 1-1.255 1.34c-.525.312-1.138.468-1.842.468-.725 0-1.394-.19-2.008-.57a4.154 4.154 0 0 1-1.44-1.54 4.536 4.536 0 0 1-.519-2.142zm16.809 2.645c-.256.513-.613.91-1.071 1.188-.446.28-.965.419-1.557.419-1.049 0-1.88-.33-2.494-.988-.613-.658-.92-1.55-.92-2.678v-4.67h1.556v4.503c0 .714.201 1.288.603 1.724.402.424.937.636 1.607.636.681 0 1.227-.212 1.64-.636.424-.436.636-1.01.636-1.724l.017-4.503h1.54v8.168h-1.557v-1.44zm7.483 1.607a4.254 4.254 0 0 1-2.142-.553 4.294 4.294 0 0 1-1.524-1.54 4.259 4.259 0 0 1-.552-2.142c0-.793.184-1.512.552-2.16a4.126 4.126 0 0 1 1.524-1.54 4.157 4.157 0 0 1 2.142-.569c.625 0 1.217.129 1.775.385a3.634 3.634 0 0 1 1.372 1.072c.368.457.597.965.686 1.523h-1.573c-.112-.435-.385-.792-.82-1.071a2.49 2.49 0 0 0-1.44-.436c-.502 0-.959.123-1.372.369-.413.245-.742.58-.988 1.004a2.895 2.895 0 0 0-.351 1.423c0 .513.117.982.351 1.406.246.413.575.742.988.987.413.246.87.369 1.372.369.547 0 1.032-.145 1.457-.435.435-.302.708-.681.82-1.139h1.556a3.196 3.196 0 0 1-.669 1.574 3.79 3.79 0 0 1-1.373 1.088 4.234 4.234 0 0 1-1.791.385zm9.134-.067c-.882 0-1.579-.257-2.093-.77-.513-.513-.77-1.256-.77-2.226v-3.8h-1.59v-1.473h1.59v-2.21h1.54v2.21h2.21v1.473h-2.21v3.766c0 .547.145.949.436 1.205.29.246.691.369 1.205.369.234 0 .424-.023.569-.067v1.422c-.246.067-.541.1-.887.1zm5.344.067c-.96 0-1.752-.24-2.377-.72-.625-.48-.976-1.133-1.054-1.958h1.473c.055.401.256.725.602.97.346.246.776.369 1.289.369.502 0 .904-.106 1.205-.318.313-.212.469-.491.469-.837 0-.402-.167-.687-.502-.854-.335-.167-.848-.318-1.54-.452a11.352 11.352 0 0 1-1.473-.385 2.325 2.325 0 0 1-.954-.653c-.257-.301-.385-.72-.385-1.255 0-.703.273-1.278.82-1.724.547-.458 1.272-.687 2.176-.687.837 0 1.557.224 2.159.67.614.435.971 1.032 1.072 1.791h-1.557c-.056-.335-.24-.608-.552-.82-.313-.223-.698-.335-1.155-.335-.436 0-.787.09-1.055.268-.268.178-.402.418-.402.72 0 .256.084.463.251.619.168.156.374.273.62.351.245.067.597.146 1.054.235.614.111 1.116.24 1.507.385.39.134.725.368 1.004.703.279.335.419.798.419 1.39 0 .48-.14.914-.419 1.305-.268.38-.642.68-1.121.904a3.78 3.78 0 0 1-1.574.318z",
    fill: "#8C8C8C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tjyctglqma",
    x: 0.652,
    y: 0.108,
    width: 578.102,
    height: 337.673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.783
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.174
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_876_1048"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_876_1048",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopProductsTableIllustration);
export default __webpack_public_path__ + "static/media/top-products-table-illustration.f2708fddb4f47c4192a5380b4c1507e6.svg";
export { ForwardRef as ReactComponent };